// extracted by mini-css-extract-plugin
module.exports = {"nbugs-main-container-loading":"nbugs-main-container-loading___3LEj8","img-box":"img-box___1nimT"};